module.exports = __webpack_public_path__ + "static/media/19_l_truba4_8.33_58.52.673c0113.png";